<div class="list-container mx-space-sm">
  @for (group of this.groupedMessages(); track group.date) {
    <div class="date-header align-center g-space-sm mx-space-md">
      <span class="line my-space-sm"></span>
      <span class="date">{{ group.date | camDate: 'weekdayShortDate' }}</span>
      <span class="line"></span>
    </div>

    @for (communication of group.messages; track communication.id) {
      <cam-communication-message-container
        class="communication mb-space-md"
        [communication]="communication"
        [conversationParticipants]="this.conversationParticipants()"
        [taskId]="this.taskId()"
        [enableReply]="this.enableReply()"
        [class.is-mine]="communication.isMine"
        [class.system]="communication.type === this.CommunicationType.System"
        (askReply)="this.readonly() ? null : this.askReply.emit($event)"
      ></cam-communication-message-container>
    }
  }
</div>
